import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, authorisationConverter, useFetchUserData } from '../../utils/AppFunctions'
import config from '../../app-config'
import { fetch_all_bulletin } from '../../api/bulletinAPI';
import 'react-toastify/dist/ReactToastify.css';
import AdminLayout from '../../layouts/AdminLayout'
import { MdAdd, MdPersonAdd } from 'react-icons/md';
import { tidy_date, tidy_date_raw, tidy_time_difference } from '../../utils/helper';
import DataTable from '../../components/ui/DataTable';

export default function BulletinPage() {
  const navigate = useNavigate()
  const { isAuthorised, userRole } = useFetchAuthorisation("user")
  let user_data = useFetchUserData()

  const [bulletin, setBulletinData] = useState([])
  const [loading, setLoading] = useState(true)
  const [query, setQuery] = useState("")
  useEffect(() => {
    fetchBulletIn()
  }, [])

  const fetchBulletIn = async () => {
    setLoading(true);
    const data = await fetch_all_bulletin();
    if (data.status === 200) {
      setBulletinData(data.data);
    }
    setLoading(false);
  }

  const table_columns = [
    {
      header: "Name",
      accessor: "title"
    },
    {
      header: "Remarks",
      accessor: "remarks",
      modifier: (data) => data || "N/A"
    },
    {
      header: "Items",
      accessor: "announcements",
      modifier: (data) => `${data.length} items`
    },
    {
      header: "Last Updated",
      accessor: "updatedAt",
      modifier: (data) => `${tidy_date(data)} (${tidy_time_difference(data)})`
    }
  ]

  return (
    <AdminLayout
      navSelected={"Bulletin"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>Bulletin</h1>
          <button
            className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200 gap-2"
            onClick={() => {
              navigate("/admin/bulletin/details?bulletin_id=new")
            }}
          >
            <MdAdd size={16} />
            New Bulletin
          </button>
        </>
      }
    >
      {/* <div className="column items-center justify-between w-100 mb-40">
        <input
          type="text"
          placeholder="Search..."
          className='text-input w-100'
          value={query}
          onChange={(e) => {
            setQuery(e.target.value)
          }}
        />
      </div> */}
      {loading ? (
        <div className="flex-row items-center flex justifyCenter w-100">
          <h1>Loading...</h1>
        </div>
      ) : (
        <div className="w-100">
          {/* {bulletin.map((data, index) => {
            if (!data.title.toLowerCase().includes(query.toLowerCase())) return null
            return (
              <div
                key={index}
                className="flex-row items-center flex justify-between w-100 card mt-10"
              >
                <div className="">
                  <h3>{data.title}</h3>
                  <h3 className='gray card-subtitle'>{data?.remarks}</h3>
                </div>
                <button
                  className="backgroundLess"
                  style={{ fontSize: 12 }}
                  onClick={() => {
                    navigate("/admin/bulletin/details?bulletin_id=" + data.id)
                  }}
                >
                  View
                </button>
              </div>
            )
          })} */}
          {/* <pre>{JSON.stringify(bulletin,null,2)}</pre> */}
          <DataTable
            columns={table_columns}
            data={bulletin}
            enableActions
            actions={(row) => {
              return (
                <div className="flex gap-2">
                  <button className="hover:underline" onClick={() => navigate(`/admin/bulletin/details?bulletin_id=${row.id}`)}>
                    Edit
                  </button>
                </div>
              )
            }}
          />
        </div>
      )}
    </AdminLayout>
  )
}
